import { render, staticRenderFns } from "./DashCompraVenta.vue?vue&type=template&id=a38718dc&scoped=true&"
import script from "./DashCompraVenta.vue?vue&type=script&lang=js&"
export * from "./DashCompraVenta.vue?vue&type=script&lang=js&"
import style0 from "./DashCompraVenta.vue?vue&type=style&index=0&id=a38718dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38718dc",
  null
  
)

export default component.exports